import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TaxReportComponent} from './tax-report.component';


export const taxReportRoutes: Routes = [
  {
    path: 'taxReport',
    component: TaxReportComponent,
    data: {
      'expectedRoles': ['Accountant', 'Accountant Admin', 'IT']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(taxReportRoutes)],
  exports: [RouterModule]
})
export class TaxReportRoutingModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report-routing.module.ts